import React, { useState } from "react";
import styles from "./Row.module.sass";
import cn from "classnames";

const Row = ({
	item,
	value,
	onChange,
	activeTable,
	setActiveTable,
	activeId,
	setActiveId,
	setData,
}) => {
	const handleClick = (item) => {
		setActiveTable(true);
		setActiveId(item.id);
		setData(item);
	};

	return (
		<>
			<div
				className={cn(
					styles.row,
					{ [styles.selected]: activeId === item.id },
					{ [styles.active]: activeTable }
				)}
			>
				<div className={styles.col}>
					{/* <Checkbox
						className={styles.checkbox}
						value={value}
						onChange={onChange}
					/> */}
				</div>
				<div className={styles.col}>
					<div className={styles.item} onClick={() => handleClick(item)}>
						<div className={styles.avatar}>
							<img src={item.avatar} alt="Avatar" />
						</div>
						<div className={styles.details}>
							<div className={styles.user}>{item.title}</div>
							<div className={styles.login}> </div>
							{/* <div className={styles.email}>{item.email}</div> */}
						</div>
					</div>
				</div>
				<div className={styles.col}>
					<div className={styles.email}>{item.description}</div>
				</div>
				{/* <div className={styles.col}>
          <div className={cn("status-green-dark", styles.purchase)}>
            {item.purchase}
          </div>
        </div> */}
			</div>
		</>
	);
};

export default Row;
